import { ExtractlyApplicationErrorType } from '../types/errors'

export abstract class ExtractlyApplicationError extends Error {
  abstract readonly _tag: ExtractlyApplicationErrorType

  constructor(message: string) {
    super(message)
    Object.setPrototypeOf(this, new.target.prototype)
  }
}

export class OfficeIsNotReadyError extends ExtractlyApplicationError {
  readonly _tag = 'OfficeIsNotReadyError'

  constructor() {
    super('Office is not ready')
  }
}

export class UserNotSubscribedError extends ExtractlyApplicationError {
  readonly _tag = 'UserNotSubscribedError'

  constructor() {
    super('User is not subscribed')
  }
}

export class FailedToFetchUserSubscriptionStatusError extends ExtractlyApplicationError {
  readonly _tag = 'FailedToFetchUserSubscriptionStatusError'
  constructor() {
    super('Failed to fetch user subscription status')
  }
}

export class MissingAuthTokenError extends ExtractlyApplicationError {
  readonly _tag = 'MissingAuthTokenError'
  constructor() {
    super('Missing authentication token')
  }
}

export class FetchTokenFailedError extends ExtractlyApplicationError {
  readonly _tag = 'FetchTokenFailedError'
  constructor() {
    super('Failed to fetch authentication token')
  }
}

export class FailedToOpenExcelDialogError extends ExtractlyApplicationError {
  readonly _tag = 'FailedToOpenExcelDialogError'
  constructor() {
    super('Failed to open Excel dialog')
  }
}

export abstract class OfficeActionError extends ExtractlyApplicationError {
  abstract readonly _tag: ExtractlyApplicationErrorType
  abstract readonly name: string
  abstract readonly code: number
}

export class AuthenticationTimeout extends OfficeActionError {
  readonly _tag = 'AuthenticationTimeout'
  readonly name = 'Authentication Timeout'
  readonly code = 1

  constructor() {
    super('The authentication process has timed out.')
  }
}

export class CookieExpiredError extends ExtractlyApplicationError {
  readonly _tag = 'CookieExpiredError'
  constructor() {
    super('The authentication cookie has expired. Please sign in again.')
  }
}

export class SetExpiredCookieError extends ExtractlyApplicationError {
  readonly _tag = 'SetExpiredCookieError'
  constructor() {
    super(
      'Failed to set the authentication cookie because it is already expired.'
    )
  }
}

export class InvalidMSTokenError extends ExtractlyApplicationError {
  readonly _tag = 'InvalidMSTokenError'
  constructor() {
    super('The provided Microsoft authentication token is invalid.')
  }
}

export class InvalidJwtTokenError extends ExtractlyApplicationError {
  readonly _tag = 'InvalidJwtTokenError'
  constructor() {
    super('The provided JWT token is invalid.')
  }
}

export class FailedToCreateFolderError extends ExtractlyApplicationError {
  readonly _tag = 'FailedToCreateFolderError'
  constructor() {
    super('Failed to create folder.')
  }
}

export class FailedToDeleteFileError extends ExtractlyApplicationError {
  readonly _tag = 'FailedToDeleteFileError'

  constructor(fileId?: string) {
    const msg = fileId
      ? `Failed to delete file with file id=${fileId}.`
      : 'Failed to delete file.'
    super(msg)
  }
}

export class FailedToDeleteFolderError extends ExtractlyApplicationError {
  readonly _tag = 'FailedToDeleteFolderError'
  constructor(folderId?: string) {
    const msg = folderId
      ? `Failed to delete folder with folder id=${folderId}.`
      : 'Failed to delete folder.'
    super(msg)
  }
}

export class FailedToCreateFileRecordError extends ExtractlyApplicationError {
  readonly _tag = 'FailedToCreateFileRecordError'
  constructor() {
    super('Failed to create file record.')
  }
}

export class FailedToUploadFileError extends ExtractlyApplicationError {
  readonly _tag = 'FailedToUploadFileError'
  constructor(fileId?: string) {
    const msg = fileId
      ? `Failed to upload file with file id=${fileId}.`
      : 'Failed to upload file.'
    super(msg)
  }
}

export class FailedToParseJsonError extends ExtractlyApplicationError {
  readonly _tag = 'FailedToParseJsonError'
  constructor() {
    super('Failed to parse JSON.')
  }
}

export class FailedToSetRumUserError extends ExtractlyApplicationError {
  readonly _tag = 'FailedToSetRumUserError'
  constructor() {
    super('Failed to set RUM user attributes.')
  }
}
